import request from '../../../shared/request'

export function getJobSiteOverviews(job_id) {
  return request(`/job/job_site_overview/${job_id}/`)
}

export function updateJobSiteOverview(payload) {
  return request(`/job/job_site_overview/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobSiteOverview(payload) {
  return request(`/job/job_site_overview/${payload.job_site_overview_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteOverview.js